import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { portfolioData } from '../data/mock';

const Testimonials = () => {
  const testimonials = portfolioData.testimonials;
  const [current, setCurrent] = useState(0);

  const next = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const prev = () => setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  const t = testimonials[current];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 md:py-32 lg:py-40 bg-[#121212]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.25, 1, 0.5, 1] }}
          className="mb-16"
        >
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] font-medium text-white/40 mb-4">Testimonials</p>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tight leading-tight text-white">
            Client Stories
          </h2>
        </motion.div>

        <div className="relative max-w-4xl">
          <span className="font-serif text-[120px] md:text-[200px] leading-none text-white/5 absolute -top-8 -left-4 select-none pointer-events-none">
            &ldquo;
          </span>

          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -30 }}
              transition={{ duration: 0.5, ease: [0.25, 1, 0.5, 1] }}
              data-testid={`testimonial-${current}`}
            >
              <div className="flex gap-1 mb-6">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-white/60 fill-white/60" />
                ))}
              </div>
              <p className="font-serif text-xl md:text-2xl lg:text-3xl font-light leading-relaxed text-white/80 italic mb-8">
                {t.text}
              </p>
              <div className="flex items-center gap-4">
                <div>
                  <p className="text-sm font-medium text-white tracking-wide">{t.name}</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-white/40 mt-1">{t.role}</p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="flex gap-3 mt-10" data-testid="testimonial-nav">
            <button
              data-testid="testimonial-prev"
              onClick={prev}
              className="w-10 h-10 border border-white/10 hover:border-white/30 flex items-center justify-center transition-colors duration-300"
            >
              <ChevronLeft className="w-4 h-4 text-white/60" />
            </button>
            <button
              data-testid="testimonial-next"
              onClick={next}
              className="w-10 h-10 border border-white/10 hover:border-white/30 flex items-center justify-center transition-colors duration-300"
            >
              <ChevronRight className="w-4 h-4 text-white/60" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
